import { ArrowRight } from "lucide-react";
import { Link } from "./LocaleLink";
import { Reveal } from "./Reveal";
import { useLang } from "../context/LanguageContext";
import { track } from "../lib/analytics";

// Promotes the existing /owner funnel after trust/management sections. Compact by design — one headline, one button.
export const OwnerEstimateBanner = ({ location, airbnb = false, className = "" }) => {
  const { t } = useLang();
  const onClick = () =>
    track(airbnb ? "airbnb_management_cta_click" : "property_management_cta_click", { cta_location: location, lead_type: "owner" });
  return (
    <section data-testid={`owner-estimate-banner-${location}`} className={`px-6 md:px-12 lg:px-24 mx-auto max-w-[1600px] ${className}`}>
      <Reveal>
        <div className="border border-primary/40 bg-secondary/60 px-8 py-10 md:px-14 md:py-12 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="max-w-2xl">
            <p className="font-accent text-[11px] uppercase tracking-[0.25em] text-primary">{t("ownerCta.overline")}</p>
            <h2 className="mt-3 font-headings text-2xl sm:text-3xl leading-tight text-foreground">{t("ownerCta.title")}</h2>
            <p className="mt-3 font-body font-light text-foreground/70 text-sm sm:text-base">{t("ownerCta.text")}</p>
          </div>
          <Link
            to="/owner"
            onClick={onClick}
            data-testid={`owner-estimate-button-${location}`}
            className="shrink-0 inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-4 uppercase tracking-[0.2em] text-xs font-body transition-all duration-300"
          >
            {t("ownerCta.button")} <ArrowRight size={15} />
          </Link>
        </div>
      </Reveal>
    </section>
  );
};
